// src/common/hooks/useUnsavedChangesWarning.ts
import { useEffect } from 'react';
import { useUnsavedChangesStore } from '@/app/store/unsavedChangesStore';

/**
 * Hook to intercept browser navigation and warn user about unsaved changes
 * Works with window.beforeunload for page refresh/close
 */
export const useUnsavedChangesWarning = () => {
  const { isDirty } = useUnsavedChangesStore();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isDirty) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);
};
